import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import FinalCTA from "@/components/sections/FinalCTA";
import { Reveal } from "@/components/motion";
import { FAQS } from "@/lib/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Seo
        title="FAQ"
        description="Frequently asked questions about StUpEco Workspace — the product, pricing, availability, security and Mission 100."
        path="/faq"
        jsonLd={jsonLd}
      />
      <PageHeader
        eyebrow="FAQ"
        title="Questions, answered honestly."
        subtitle="Everything you might want to know about StUpEco Workspace and where we are in the journey."
      />
      <section className="border-b border-border py-20 sm:py-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-border" data-testid={`faq-page-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-base font-medium tracking-tight hover:no-underline sm:text-lg">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-muted-foreground sm:text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
